import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { useSEO } from '../../utils/seo';

export default function Sell() {
  useSEO({
    title: 'Sell Your Home in Northern California | Free Home Valuation | Jeffery Long eXp Realty',
    description: 'Get your FREE home valuation with local comparables instantly. Jeffery Long - 40+ years experience selling homes in Sacramento, El Dorado Hills, Cameron Park. Expert marketing, professional photography, and proven selling strategies. CA DRE #02234432',
    keywords: 'sell home California, home valuation, Sacramento home selling, Northern California realtor, property valuation, home appraisal, real estate agent, sell house fast, Cameron Park, El Dorado Hills',
    canonical: '/sell',
    ogTitle: 'Sell Your Home in Northern California | Free Home Valuation',
    ogDescription: 'Get your FREE home valuation complete with local comparables. Expert selling strategies from Jeffery Long with 40+ years experience.',
    ogImage: 'https://public.readdy.ai/ai/img_res/419774fafd7121638e7c5bd25016f5b2.jpg',
    schema: {
      "@context": "https://schema.org",
      "@type": "Service",
      "serviceType": "Home Selling Services",
      "provider": {
        "@type": "RealEstateAgent",
        "name": "Jeffery Long - eXp Realty",
        "telephone": "+1-916-257-8244",
        "email": "realestatedevelopmentauthority@gmail.com"
      },
      "areaServed": {
        "@type": "State",
        "name": "California"
      },
      "description": "Professional home selling services including free home valuation, market analysis, professional photography, and expert marketing strategies.",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "USD",
        "description": "Free Home Valuation"
      }
    }
  });

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="relative bg-gradient-to-r from-blue-900 to-blue-700 text-white py-20">
          <div className="absolute inset-0 bg-black/30"></div>
          <div 
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage: `url('https://readdy.ai/api/search-image?query=luxury%20modern%20home%20exterior%20with%20beautiful%20landscaping%20and%20professional%20real%20estate%20photography%20style%20with%20clean%20simple%20background%20perfect%20for%20selling%20homes&width=1200&height=600&seq=sell-hero&orientation=landscape')`
            }}
          ></div>
          <div className="relative container mx-auto px-4 text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">Sell Your Home</h1>
            <p className="text-xl md:text-2xl mb-8">Get your FREE Home Valuation complete with local comparables instantly</p>
            <button className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors">
              Get Your Home Value
            </button>
          </div>
        </section>

        {/* Home Valuation Form */}
        <section className="py-16 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <div className="bg-white rounded-lg shadow-lg p-8">
                <h2 className="text-3xl font-bold text-center mb-8">Free Home Valuation</h2>
                <form className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Property Address</label>
                    <input type="text" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter your property address" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">City</label>
                    <input type="text" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="City" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">First Name</label>
                    <input type="text" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="First Name" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Last Name</label>
                    <input type="text" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Last Name" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
                    <input type="email" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Email Address" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Phone</label>
                    <input type="tel" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Phone Number" />
                  </div>
                  <div className="md:col-span-2">
                    <button type="submit" className="w-full bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-md text-lg font-semibold transition-colors">
                      Get My Home Value
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>

        {/* Why Sell With Us */}
        <section className="py-16">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl font-bold text-center mb-12">Why Sell With Jeffery Long?</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-home-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-semibold mb-4">40 Years Experience</h3>
                <p className="text-gray-600">With over 40 years in real estate, I have the expertise to get your home sold quickly and for the best price.</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-line-chart-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-semibold mb-4">Market Analysis</h3>
                <p className="text-gray-600">Get a comprehensive market analysis to price your home competitively in today's market.</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-team-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-semibold mb-4">Full Service Team</h3>
                <p className="text-gray-600">Our dedicated team handles every aspect of your home sale from listing to closing.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Selling Process */}
        <section className="py-16 bg-gray-50">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl font-bold text-center mb-12">Our Selling Process</h2>
            <div className="max-w-4xl mx-auto">
              <div className="space-y-8">
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold">1</div>
                  <div>
                    <h3 className="text-xl font-semibold mb-2">Initial Consultation</h3>
                    <p className="text-gray-600">We'll meet to discuss your goals, timeline, and create a customized selling strategy.</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold">2</div>
                  <div>
                    <h3 className="text-xl font-semibold mb-2">Home Preparation</h3>
                    <p className="text-gray-600">We'll provide recommendations to maximize your home's appeal and value.</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold">3</div>
                  <div>
                    <h3 className="text-xl font-semibold mb-2">Professional Marketing</h3>
                    <p className="text-gray-600">Your home will be professionally photographed and marketed across all major platforms.</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold">4</div>
                  <div>
                    <h3 className="text-xl font-semibold mb-2">Showings & Negotiations</h3>
                    <p className="text-gray-600">We'll handle all showings and negotiate the best terms for your sale.</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold">5</div>
                  <div>
                    <h3 className="text-xl font-semibold mb-2">Closing</h3>
                    <p className="text-gray-600">We'll guide you through the closing process to ensure a smooth transaction.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Contact CTA */}
        <section className="py-16 bg-blue-600 text-white">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl font-bold mb-4">Ready to Sell Your Home?</h2>
            <p className="text-xl mb-8">Contact Jeffery Long today for your free consultation</p>
            <div className="flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-6">
              <a href="tel:916-257-8244" className="bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors">
                Call (916) 257-8244
              </a>
              <a href="mailto:realestatedevelopmentauthority@gmail.com" className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-blue-600 transition-colors">
                Email Us
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
